/* src/app/core/layout/components/content/content.component.scss */
:host {
  position: relative;
}
/*# sourceMappingURL=content.component-3NH7AXSG.css.map */
